export class BookingsHttp {
    /**
     * Get all bookings by day
     * @param day
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async getBookingsByDay(day) {
        try {
            return await window.axios.get(`bookings/${day}`);
        } catch (e) {
            return Promise.reject(e);
        }
    }

    /**
     * Get all bookings by distance
     * @param day
     * @param postcode
     * @param direction
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async getBookingsByDistance(day, postcode, direction) {
        try {
            if (direction) {
                return await window.axios.get(`bookings/distance/${day}/${postcode}?direction=true`);
            } else {
                return await window.axios.get(`bookings/distance/${day}/${postcode}`);
            }
        } catch (e) {
            return Promise.reject(e);
        }
    }

    /**
     * Sets a booking to be rescheduled
     * @param id
     * @return {Promise<void>}
     */
    static async setBookingToReschedule(id) {
        try {
            return await window.axios.put(`bookings/reschedule/${id}`);
        } catch (e) {
            return Promise.reject(e);
        }
    }

    /**
     * Sets a booking to be cancelled
     * @param id
     * @return {Promise<void>}
     */
    static async setBookingToCancel(id) {
        try {
            return await window.axios.put(`bookings/cancel/${id}`);
        } catch (e) {
            return Promise.reject(e);
        }
    }


    /**
     * Get all bookings by day for a tech
     * @param day
     * @param id
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async getBookingsByDayAndTech(day, id) {
        try {
            return await window.axios.get(`bookings/tech/${id}/${day}`);
        } catch (e) {
            return Promise.reject(e);
        }
    }

    /**
     * Get all bookings by psk
     * @param id
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async getBookingsByPsk(id) {
        try {
            return await window.axios.get(`public/customer/contracts/${id}`);
        } catch (e) {
            return Promise.reject(e);
        }
    }

    /**
     * Send out contracts
     * @param ids
     * @param day
     * @return {Promise<AxiosResponse<any>>}
     */
    static async sendContracts(ids, day) {
        try {
            return await window.axios.post(`bookings/contracts/${day}`, {ids: ids.toString()});
        } catch (e) {
            return Promise.reject(e);
        }
    }

    /**
     * Create a new booking
     * @param booking
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async createBooking(booking) {
        try {
            return await window.axios.post(`bookings`, booking);
        } catch (e) {
            return Promise.reject(e);
        }
    }

    /**
     * Creates a split booking and gets ID back
     * @param booking
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async createSplitBooking(booking) {
        try {
            return await window.axios.post(`bookings/split`, booking);
        } catch (e) {
            return Promise.reject(e);
        }
    }

    /**
     * Updates a booking
     * @param booking
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async updateBooking(booking) {
        try {
            return await window.axios.put(`bookings`, booking);
        } catch (e) {
            return Promise.reject(e);
        }
    }

    /**
     * Gets a single booking
     * @param id
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async getSingleBooking(id) {
        try {
            return await window.axios.get(`bookings/single/${id}`);
        } catch (e) {
            return Promise.reject(e);
        }
    }

    /**
     * Search bookings
     * @param q
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async searchForBookings(q) {
        try {
            return await window.axios.get(`bookings/search?q=${q}`);
        } catch (e) {
            return Promise.reject(e);
        }
    }

    /**
     * Delete a booking
     * @param id
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async deleteBooking(id) {
        try {
            return await window.axios.delete(`bookings/${id}`);
        } catch (e) {
            return Promise.reject(e);
        }
    }

    /**
     * Preview a booking
     * @param id
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async previewBooking(id) {
        try {
            return await window.axios.get(`bookings/single/${id}/email`);
        } catch (e) {
            return Promise.reject(e);
        }
    }

    /**
     * Preview a booking
     * @param booking
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async previewBookingNotSaved(booking) {
        try {
            return await window.axios.post(`bookings/single/email`, booking);
        } catch (e) {
            return Promise.reject(e);
        }
    }

    static async fetchCumulativeTotals(day) {
        try {
            return await window.axios.get(`bookings/cumulative/${day}`);
        } catch (e) {
            return Promise.reject(e);
        }
    }
}
